import React from "react";
import { MetricCard, MiniBarChart, Panel } from "../../components/ui/dashboard";

const TransporterDashboard: React.FC = () => {
  return (
    <div className="p-4 md:p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricCard title="Active Vehicles" value="58" accent="blue" />
        <MetricCard title="Drivers On Duty" value="36" accent="green" />
        <MetricCard title="In-Transit Loads" value="44" accent="amber" />
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <Panel title="Earnings & Charges" subtitle="Date range summary">
          <MiniBarChart values={[32, 45, 50, 71, 60, 65, 77]} />
        </Panel>
        <Panel title="Live Map" subtitle="All active vehicles">
          <div className="h-44 rounded-xl border border-slate-100 bg-gradient-to-br from-slate-100 via-blue-50 to-slate-200 flex items-center justify-center text-slate-500 text-sm">
            Live vehicle map placeholder
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default TransporterDashboard;